/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_vol_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do recipe conversions between metric and US cups never look exact?`)
};

const es_uc_vol_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué las conversiones de recetas entre métrico y tazas estadounidenses nunca se ven exactas?`)
};

const de_uc_vol_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum wirken Rezeptumrechnungen zwischen metrischen und US-Cups nie exakt?`)
};

const nl_uc_vol_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom zien receptconversies tussen metrisch en Amerikaanse kopjes er nooit exact uit?`)
};

const fr_uc_vol_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les conversions de recettes entre unités métriques et tasses américaines n'ont-elles jamais l'air exactes ?`)
};

const it_uc_vol_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché le conversioni di ricette tra metrico e tazze USA non sembrano mai esatte?`)
};

const pt_br2_uc_vol_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que conversões de receitas entre métrica e xícara US nunca parecem exatas?`)
};

const pt_uc_vol_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que as conversões de receitas entre métrico e chávenas americanas nunca parecem exactas?`)
};

const ja_uc_vol_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メートル法と米国カップ間のレシピ変換が正確に見える理由は何ですか?`)
};

const zh_uc_vol_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_vol_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_vol_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_vol_faq4_q", locale)
	if (locale === "en") return en_uc_vol_faq4_q(inputs)
	if (locale === "es") return es_uc_vol_faq4_q(inputs)
	if (locale === "de") return de_uc_vol_faq4_q(inputs)
	if (locale === "nl") return nl_uc_vol_faq4_q(inputs)
	if (locale === "fr") return fr_uc_vol_faq4_q(inputs)
	if (locale === "it") return it_uc_vol_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_vol_faq4_q(inputs)
	if (locale === "pt") return pt_uc_vol_faq4_q(inputs)
	if (locale === "ja") return ja_uc_vol_faq4_q(inputs)
	return zh_uc_vol_faq4_q(inputs)
};